import { getQueryVariable, cache } from './index';

function Insrc() {
  this.code = cache.getCookie('insrc');
  const queryInsrc = getQueryVariable('utm_term') || getQueryVariable('insrc');
  const utmSource = getQueryVariable('utm_source');
  const utmMedium = getQueryVariable('utm_medium');
  const utmCampaign = getQueryVariable('utm_campaign');

  if (queryInsrc && /^[A-Za-z0-9\-\_]+$/.test(queryInsrc)) {
    this.code = queryInsrc;
    this.source = utmSource;
    this.medium = utmMedium;
    this.campaign = utmCampaign;
    cache.setCookie('insrc', queryInsrc, { expires: 30 });
    // 携带任意可选utm参数则覆盖，未携带任意则删除
    if (utmSource) {
      cache.setCookie('insta360.utm_source', utmSource, { expires: 30 });
    } else {
      cache.removeCookie('insta360.utm_source');
    }
    if (utmMedium) {
      cache.setCookie('insta360.utm_medium', utmMedium, { expires: 30 });
    } else {
      cache.removeCookie('insta360.utm_medium');
    }
    if (utmCampaign) {
      cache.setCookie('insta360.utm_campaign', utmCampaign, { expires: 30 });
    } else {
      cache.removeCookie('insta360.utm_campaign');
    }
  }
}

// 更新分销码并移除来源
export const updateInsrc = (insrc, source) => {
  cache.removeCookie('insrc');
  cache.setCookie('insrc', insrc, { expires: 30 });
  cache.setCookie('insta360.utm_source', source, { expires: 30 });
  ['insta360.utm_medium', 'insta360.utm_campaign'].forEach((key) => {
    cache.removeCookie(key);
  });
};

Insrc.prototype.getInsrc = function () {
  return this.code && this.code.toUpperCase();
};

export default Insrc;
